/* ABC: просмотр фото на телефоне.

   Владелец: «люди приближают двумя пальцами, а у нас по тапу», «свайп
   не перелистывает фото, а только сдвигает», «листается сверху вниз —
   странно». Поэтому на сенсорных экранах:
     — лента фото горизонтальная, один кадр на экран, свайп листает ровно
       на один кадр (scroll-snap-stop:always, это в CSS);
     — приближение двумя пальцами (щипок) от точки между пальцами, до 4x;
     — пока фото приближено, одним пальцем его двигают, лента не листается;
     — двойной тап — быстро приблизить в точку / вернуть обратно;
     — снизу точки: какой кадр из скольких.
   На ПК всё остаётся как было (клик-зум и слежение за курсором). */
(function () {
  var mqTouch = window.matchMedia('(hover: none) and (pointer: coarse)');
  var mqNarrow = window.matchMedia('(max-width: 749px)');
  function isTouch() { return mqTouch.matches || mqNarrow.matches; }
  window.abcZoomIsTouch = isTouch;

  var MAX = 4;
  var DOUBLE = 2.5;
  var zoom = new WeakMap();     // img -> {s, x, y}

  function gallery() {
    return document.querySelector(':is(zoom-dialog,abc-zoom) dialog[open] .dialog-zoomed-gallery');
  }
  function frameOf(img) { return img.closest('li'); }
  function get(img) { return zoom.get(img) || { s: 1, x: 0, y: 0 }; }

  /* двигаем через translate+scale от левого верхнего угла кадра —
     так проще держать точку под пальцами на месте */
  function apply(img, st, animate) {
    img.style.transition = animate ? 'transform .25s cubic-bezier(.4,0,.2,1)' : 'none';
    img.style.transformOrigin = '0 0';
    img.style.transform = 'translate(' + st.x + 'px,' + st.y + 'px) scale(' + st.s + ')';
    zoom.set(img, st);
    var g = gallery();
    var zoomed = st.s > 1.01;
    img.dataset.abcPinch = zoomed ? '1' : '';
    if (g) g.classList.toggle('abc-pinching', zoomed);
  }

  /* фото не должно уезжать из кадра: края кадра всегда закрыты картинкой */
  function clamp(img, st) {
    var f = frameOf(img).getBoundingClientRect();
    var minX = f.width * (1 - st.s), minY = f.height * (1 - st.s);
    st.x = Math.min(0, Math.max(minX, st.x));
    st.y = Math.min(0, Math.max(minY, st.y));
    return st;
  }

  function reset(img, animate) { apply(img, { s: 1, x: 0, y: 0 }, animate); }

  function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
  function mid(a, b) { return { x: (a.clientX + b.clientX) / 2, y: (a.clientY + b.clientY) / 2 }; }

  var g0 = null;          // жест щипка
  var p0 = null;          // жест перетаскивания
  var lastTap = null;     // для двойного тапа

  function onStart(e) {
    if (!isTouch()) return;
    var img = e.target.closest && e.target.closest('.dialog-zoomed-gallery img');
    if (!img) return;
    var f = frameOf(img).getBoundingClientRect();
    var st = get(img);

    if (e.touches.length === 2) {
      var m = mid(e.touches[0], e.touches[1]);
      /* точка фото под пальцами в «несжатых» координатах кадра */
      g0 = {
        img: img, s: st.s, d: dist(e.touches[0], e.touches[1]),
        px: (m.x - f.left - st.x) / st.s,
        py: (m.y - f.top - st.y) / st.s
      };
      p0 = null;
      e.preventDefault();
      return;
    }

    if (e.touches.length === 1) {
      var t = e.touches[0];
      /* двойной тап */
      var now = Date.now();
      if (lastTap && now - lastTap.t < 300 &&
          Math.hypot(t.clientX - lastTap.x, t.clientY - lastTap.y) < 30) {
        lastTap = null;
        e.preventDefault();
        if (st.s > 1.01) { reset(img, true); return; }
        var s = DOUBLE;
        var px = (t.clientX - f.left), py = (t.clientY - f.top);
        apply(img, clamp(img, { s: s, x: px - px * s, y: py - py * s }), true);
        return;
      }
      lastTap = { t: now, x: t.clientX, y: t.clientY };

      /* одним пальцем двигаем только приближенное фото */
      if (st.s > 1.01) {
        p0 = { img: img, x: t.clientX, y: t.clientY, sx: st.x, sy: st.y, s: st.s };
        e.preventDefault();
      }
    }
  }

  function onMove(e) {
    if (g0 && e.touches.length === 2) {
      var img = g0.img;
      var f = frameOf(img).getBoundingClientRect();
      var m = mid(e.touches[0], e.touches[1]);
      var s = Math.min(MAX, Math.max(1, g0.s * dist(e.touches[0], e.touches[1]) / g0.d));
      /* та же точка фото остаётся под пальцами, даже если их ведут */
      apply(img, clamp(img, {
        s: s,
        x: m.x - f.left - g0.px * s,
        y: m.y - f.top - g0.py * s
      }), false);
      e.preventDefault();
      return;
    }
    if (p0 && e.touches.length === 1) {
      var t = e.touches[0];
      apply(p0.img, clamp(p0.img, {
        s: p0.s,
        x: p0.sx + (t.clientX - p0.x),
        y: p0.sy + (t.clientY - p0.y)
      }), false);
      e.preventDefault();
    }
  }

  function onEnd(e) {
    if (g0 && e.touches.length < 2) {
      var img = g0.img;
      /* почти не приблизили — возвращаем плавно в исходное */
      if (get(img).s < 1.05) reset(img, true);
      g0 = null;
    }
    if (p0 && e.touches.length === 0) p0 = null;
  }

  document.addEventListener('touchstart', onStart, { passive: false });
  document.addEventListener('touchmove', onMove, { passive: false });
  document.addEventListener('touchend', onEnd, { passive: true });
  document.addEventListener('touchcancel', onEnd, { passive: true });

  /* ── точки «кадр N из M» ── */
  function dots(g) {
    var d = g.closest('dialog');
    var box = d.querySelector('.abc-viewer-dots');
    var n = g.children.length;
    if (!box) {
      box = document.createElement('div');
      box.className = 'abc-viewer-dots';
      d.appendChild(box);
    }
    if (box.children.length !== n) {
      box.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var s = document.createElement('span');
        s.className = 'abc-viewer-dots__dot';
        box.appendChild(s);
      }
    }
    var cur = Math.round(g.scrollLeft / Math.max(1, g.clientWidth));
    [].forEach.call(box.children, function (el, k) {
      el.classList.toggle('is-current', k === cur);
    });
    box.hidden = n < 2;
  }

  /* ── стрелки ‹ › по бокам (выбор владельца по Balenciaga) ── */
  function current(g) { return Math.round(g.scrollLeft / Math.max(1, g.clientWidth)); }
  function goTo(g, i) {
    var n = g.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    g.querySelectorAll('img[data-abc-pinch="1"]').forEach(function (img) { reset(img, false); });
    var target = i * g.clientWidth;
    g.scrollTo({ left: target, behavior: 'smooth' });
    /* сразу после открытия плавная прокрутка иногда глохнет, пока тема
       доводит ленту до нужного кадра — добиваем без анимации */
    setTimeout(function () {
      if (Math.abs(g.scrollLeft - target) > 4) g.scrollLeft = target;
    }, 450);
  }
  function arrows(g) {
    var d = g.closest('dialog');
    var prev = d.querySelector('.abc-viewer-arrow--prev');
    var next = d.querySelector('.abc-viewer-arrow--next');
    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'abc-viewer-arrow abc-viewer-arrow--prev';
      prev.setAttribute('aria-label', 'Previous photo');
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'abc-viewer-arrow abc-viewer-arrow--next';
      next.setAttribute('aria-label', 'Next photo');
      d.appendChild(prev);
      d.appendChild(next);
      prev.addEventListener('click', function (e) { e.stopPropagation(); goTo(g, current(g) - 1); });
      next.addEventListener('click', function (e) { e.stopPropagation(); goTo(g, current(g) + 1); });
    }
    var i = current(g), n = g.children.length;
    prev.hidden = i <= 0;
    next.hidden = i >= n - 1;
  }

  function bind(g) {
    if (g.dataset.abcTouchBound) return;
    g.dataset.abcTouchBound = '1';
    g.addEventListener('scroll', function () {
      dots(g);
      arrows(g);
      /* ушли на другой кадр — прошлый возвращаем в обычный размер */
      /* лента двинулась — значит человек листает: увеличение сбрасываем
         сразу у всех кадров, а не когда кадр уже уехал (раньше приближенный
         кадр проезжал мимо в увеличенном виде и таким же оставался) */
      /* листают — у ВСЕХ кадров полностью убираем свои трансформации, без
         анимации: иначе прошлый кадр «улетал» и висел смещённым */
      g.querySelectorAll('img').forEach(function (img) {
        if (!img.style.transform) return;
        zoom.delete(img);
        img.dataset.abcPinch = '';
        img.dataset.abcZoomed = '';
        img.style.transition = 'none';
        img.style.transform = '';
        img.style.transformOrigin = '';
      });
      g.classList.remove('abc-pinching');
    }, { passive: true });
  }

  new MutationObserver(function () {
    if (!isTouch()) return;
    var g = gallery();
    if (!g) return;
    bind(g);
    dots(g);
    arrows(g);
  }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['open'] });

  /* при закрытии — всё обнуляем */
  document.addEventListener('close', function (e) {
    if (!e.target || e.target.tagName !== 'DIALOG') return;
    e.target.querySelectorAll('.dialog-zoomed-gallery img').forEach(function (img) {
      zoom.delete(img);
      img.dataset.abcPinch = '';
    });
    var g = e.target.querySelector('.dialog-zoomed-gallery');
    if (g) g.classList.remove('abc-pinching');
  }, true);
})();

